import EmployeeGallery from "./employeeGallery";
export default EmployeeGallery;